var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLounges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6735 29.0729C28.3381 29.0729 28.0664 28.8012 28.0664 28.4658V9.25558C28.0664 8.92013 28.3381 8.64844 28.6735 8.64844C29.009 8.64844 29.2807 8.92013 29.2807 9.25558V28.4658C29.2807 28.8012 29.009 29.0729 28.6735 29.0729Z",
    fill: "url(#paint0_linear_712_992)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 9.86272H23.4548C23.1194 9.86272 22.8477 9.59103 22.8477 9.25558C22.8477 8.92013 23.1194 8.64844 23.4548 8.64844H33.8945C34.23 8.64844 34.5017 8.92013 34.5017 9.25558C34.5017 9.59103 34.23 9.86272 33.8945 9.86272Z",
    fill: "url(#paint1_linear_712_992)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0584 29.0729H27.2868C26.9514 29.0729 26.6797 28.8012 26.6797 28.4658C26.6797 28.1303 26.9514 27.8586 27.2868 27.8586H30.0584C30.3939 27.8586 30.6656 28.1303 30.6656 28.4658C30.6656 28.8012 30.3939 29.0729 30.0584 29.0729Z",
    fill: "url(#paint2_linear_712_992)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8337 9.86276C26.4983 9.86276 26.2266 9.59106 26.2266 9.25561V6.39596C26.2266 6.06052 26.4983 5.78882 26.8337 5.78882C27.1692 5.78882 27.4408 6.06052 27.4408 6.39596V9.25561C27.4408 9.59106 27.1692 9.86276 26.8337 9.86276Z",
    fill: "url(#paint3_linear_712_992)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7599 3.15986C29.6598 2.94888 29.4457 2.81531 29.2135 2.81531H24.4504C24.2167 2.81531 24.0042 2.94888 23.904 3.15986C23.8023 3.37084 23.8311 3.61978 23.9769 3.8019L26.3584 6.77385C26.4737 6.91804 26.6483 7.00153 26.832 7.00153C27.0156 7.00153 27.1902 6.91805 27.3056 6.77385L29.6871 3.8019C29.8328 3.61976 29.8616 3.37082 29.7599 3.15986Z",
    fill: "url(#paint4_linear_712_992)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2603 11.4854H21.6532L20.6817 5.09805C20.2507 2.6816 18.3989 0.927124 16.2738 0.927124H7.98012C5.8551 0.927124 4.00348 2.68176 3.57216 5.11048L2.60073 11.4854H1.99359C1.16788 11.4854 0.5 12.1593 0.5 12.979V15.1161C0.5 15.9418 1.16788 16.6097 1.99359 16.6097C2.15145 16.6097 2.27288 16.7311 2.27288 16.889V23.3004C2.27288 24.1261 2.94681 24.8001 3.77253 24.8001H20.4873C21.313 24.8001 21.9809 24.1261 21.9809 23.3004V16.889C21.9809 16.7311 22.1023 16.6097 22.2602 16.6097C23.0859 16.6097 23.7538 15.9418 23.7538 15.1161V12.979C23.7538 12.1593 23.086 11.4854 22.2603 11.4854ZM19.1943 12.6997C18.6114 12.6997 18.1378 13.1733 18.1378 13.7561V21.2785C18.1378 21.6185 17.8646 21.8856 17.5307 21.8856C17.1907 21.8856 16.9235 21.6185 16.9235 21.2785V15.7779C13.736 14.6061 10.5183 14.6061 7.33046 15.7779V21.2785C7.33046 21.6185 7.06332 21.8856 6.72332 21.8856C6.38939 21.8856 6.11618 21.6185 6.11618 21.2785V13.7561C6.11618 13.1733 5.64259 12.6997 5.05973 12.6997C4.7258 12.6997 4.45259 12.4265 4.45259 12.0925C4.45259 11.7586 4.7258 11.4854 5.05973 11.4854C6.31653 11.4854 7.33046 12.5054 7.33046 13.7561V14.4908C10.518 13.4161 13.7357 13.4161 16.9235 14.4908V13.7561C16.9235 12.5054 17.9375 11.4854 19.1943 11.4854C19.5282 11.4854 19.8014 11.7586 19.8014 12.0925C19.8014 12.4265 19.5282 12.6997 19.1943 12.6997Z",
    fill: "url(#paint5_linear_712_992)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53292 29.0729C4.19748 29.0729 3.92578 28.8012 3.92578 28.4658V26.3802C3.92578 26.0448 4.19748 25.7731 4.53292 25.7731C4.86837 25.7731 5.14007 26.0448 5.14007 26.3802V28.4658C5.14007 28.8012 4.86837 29.0729 4.53292 29.0729Z",
    fill: "url(#paint6_linear_712_992)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7243 29.0729C19.3889 29.0729 19.1172 28.8012 19.1172 28.4658V26.3802C19.1172 26.0448 19.3889 25.7731 19.7243 25.7731C20.0598 25.7731 20.3315 26.0448 20.3315 26.3802V28.4658C20.3315 28.8012 20.0598 29.0729 19.7243 29.0729Z",
    fill: "url(#paint7_linear_712_992)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8929 29.0729H1.10714C0.771697 29.0729 0.5 28.8012 0.5 28.4658C0.5 28.1303 0.771697 27.8586 1.10714 27.8586H33.8929C34.2283 27.8586 34.5 28.1303 34.5 28.4658C34.5 28.8012 34.2283 29.0729 33.8929 29.0729Z",
    fill: "url(#paint8_linear_712_992)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_992",
    x1: 28.6735,
    y1: 8.64844,
    x2: 28.6736,
    y2: 43.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_712_992",
    x1: 28.6747,
    y1: 8.64844,
    x2: 28.6747,
    y2: 10.7355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_712_992",
    x1: 28.6726,
    y1: 27.8586,
    x2: 28.6726,
    y2: 29.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_712_992",
    x1: 26.8337,
    y1: 5.78882,
    x2: 26.8337,
    y2: 12.7909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_712_992",
    x1: 26.832,
    y1: 2.81531,
    x2: 26.832,
    y2: 10.0104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_712_992",
    x1: 12.1269,
    y1: 0.927124,
    x2: 12.1269,
    y2: 41.9588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_712_992",
    x1: 4.53292,
    y1: 25.7731,
    x2: 4.53292,
    y2: 31.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_712_992",
    x1: 19.7243,
    y1: 25.7731,
    x2: 19.7243,
    y2: 31.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_712_992",
    x1: 17.5,
    y1: 27.8586,
    x2: 17.5,
    y2: 29.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A152E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLounges);
export default __webpack_public_path__ + "static/media/lounges.1febd2fd180daa1017297c671d18fce7.svg";
export { ForwardRef as ReactComponent };